import React, { useEffect, useState } from 'react'
import { Footer } from 'pages/Footer'
import HeaderCompleto from 'pages/Header/Content/pages/HeaderNavegacion'
import { useWebview } from 'hooks/useWebview'

export default function Test() {

    const { typeNav, typeMovile } = useWebview()

    const [userAgent, setUserAgent] = useState()
    useEffect(() => {
        setUserAgent(navigator.userAgent)
    },[])

    return (
        <div>
            <HeaderCompleto />
            <div style={{'padding':'60px 20px 0', 'margin': '20px auto 0', 'box-sizing': 'border-box', 'line-height': '1.4'}}>
                <h1>UA: {userAgent}</h1>
                <h1>typeNav: {typeNav}</h1>
            </div>
            <Footer />
        </div>
    )
}